/* eslint no-console:off */
/* eslint no-class-assign:off */
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import * as actions from '../actions';
import { getLang, getEdition, getIsEditionsFetching } from '../reducers';
import Home from './Home';
import Header from './Header';
import Loading from '../components/Loading';
import { updateFoldClass, isFront, closeHighlights, resetFoldScrollPosition } from '../ui-helpers';

class App extends Component {
  constructor() {
    super();
    this.front = true;
    this.foldClass = 'on-landing';
    this.switchEdition = this.switchEdition.bind(this);
    this.goToNextEdition = this.goToNextEdition.bind(this);
    this.goToPreviousEdition = this.goToPreviousEdition.bind(this);
  }
  componentDidMount() {
    const { setLang } = this.props;
    setLang(this.props.params.lang);
    this.fetchData();
    this.foldClass = updateFoldClass(this.props);
  }
  componentWillReceiveProps(nextProps) {
    const { location, params, edition } = nextProps;
    if (this.props.edition.id !== edition.id) {
      if (location.pathname) {
        browserHistory.push(`${location.pathname}?edition=${edition.id}`);
      } else {
        browserHistory.push(`/?edition=${edition.id}`);
      }
    }
    this.front = isFront(location.pathname, params);
    this.foldClass = updateFoldClass(nextProps);
    if (location.pathname !== this.props.location.pathname) {
      closeHighlights();
    }
  }
  componentDidUpdate() {
    if (this.front) {
      resetFoldScrollPosition('.fold__col__body--happenings');
    }
  }
  switchEdition(direction) {
    const { changeEdition } = this.props;
    changeEdition(direction);
  }
  goToNextEdition() {
    this.switchEdition('next');
  }
  goToPreviousEdition() {
    this.switchEdition('prev');
  }
  fetchData() {
    const { fetchEditions, location } = this.props;
    fetchEditions(location.query.edition);
  }
  render() {
    const { lang, children, edition, isFetching } = this.props;
    if (isFetching || typeof edition.id === 'undefined') {
      return (
        <div className={`${this.front ? 'is-front' : 'inner'} ${this.foldClass} main-wrapper`}>
          <Loading />
        </div>
      );
    }
    const nested = React.Children.map(children, child =>
      React.cloneElement(child, {
        edition,
        lang,
      }),
    );
    return (
      <div className={`${this.front ? 'is-front' : 'inner'} ${this.foldClass} main-wrapper`}>
        <Header
          lang={lang}
          edition={edition}
          onClickNext={this.goToNextEdition}
          onClickPrev={this.goToPreviousEdition}
        />
        <main>
          <Home
            lang={lang}
            edition={edition}
            front={this.front}
            isFetching={isFetching}
          />
          { nested }
        </main>
      </div>
    );
  }
}

App.propTypes = {
  lang: PropTypes.string.isRequired,
  children: PropTypes.node,
  edition: PropTypes.shape({
    background: PropTypes.string,
    backgroundTextColor: PropTypes.string,
    id: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
  fetchEditions: PropTypes.func.isRequired,
  setLang: PropTypes.func.isRequired,
  changeEdition: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  isFetching: PropTypes.bool.isRequired,
  params: PropTypes.objectOf(PropTypes.string).isRequired,
};

App.defaultProps = {
  children: undefined,
};

const mapStateToProps = state => ({
  lang: getLang(state),
  edition: getEdition(state),
  isFetching: getIsEditionsFetching(state),
});

App = connect(
  mapStateToProps,
  actions,
)(App);

export default App;



// WEBPACK FOOTER //
// ./js/containers/App.js